import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import useFirebaseConfig from "../../hooks/useFirebaseConfig";
import { setConfig } from "../../store/actions/config";


const FirebaseProvider = ({ children, setConfigurationToStore }) => {
  const [config, error, loading] = useFirebaseConfig();

  if (config) setConfigurationToStore(config);
  if (loading) return null;

  return <>{children}</>;
};

FirebaseProvider.propTypes = {
  children: PropTypes.node.isRequired,
  setConfigurationToStore: PropTypes.func.isRequired,
};


const mapDispatchToProps = (dispatch) => ({
  setConfigurationToStore: (config) => dispatch(setConfig(config)),
});


export default connect(null, mapDispatchToProps)(FirebaseProvider);


// WEBPACK FOOTER //
// ./src/js/hocs/FirebaseProvider/firebaseProvider.jsx